import * as React from 'react';
import { Close } from '@wix/wix-ui-icons-common/on-stage';
import { IconButton } from '../IconButton';
import { Text } from '../Text';
import { TPAComponentsConsumer } from '../TPAComponentsConfig';
import { POPOVER_DATA_KEYS } from './dataHooks';
import { KEY_CODES } from '../../common/keyCodes';
import { st, classes } from './CalendarPopover.st.css';
import { CalendarPopoverSides, } from './types';
/** CalendarPopover */
export class CalendarPopover extends React.Component {
    constructor() {
        super(...arguments);
        this.iconRef = React.createRef();
        this.lastActiveElement = null;
        this.getDataAttributes = () => {
            const { withShadow, withArrow, arrowSide, title, arrowTop, animated, isShown, manualFocus, } = this.props;
            return {
                [POPOVER_DATA_KEYS.ArrowTop]: arrowTop,
                [POPOVER_DATA_KEYS.ArrowSide]: arrowSide,
                [POPOVER_DATA_KEYS.Title]: title,
                [POPOVER_DATA_KEYS.WithArrow]: withArrow,
                [POPOVER_DATA_KEYS.WithShadow]: withShadow,
                [POPOVER_DATA_KEYS.Animated]: animated,
                [POPOVER_DATA_KEYS.Shown]: isShown,
                [POPOVER_DATA_KEYS.ManualFocus]: manualFocus,
            };
        };
        this._focusLastActive = () => {
            !this.props.manualFocus &&
                this.lastActiveElement &&
                this.lastActiveElement.focus();
        };
        this._onEsc = (e) => {
            if (e.keyCode === KEY_CODES.Esc) {
                this.props.onClose();
            }
        };
        this._manageA11y = () => {
            if (this.props.isShown) {
                document.addEventListener('keyup', this._onEsc);
                this.lastActiveElement = document.activeElement;
                !this.props.manualFocus && this.iconRef.current.focus();
            }
        };
    }
    componentDidUpdate(prevProps) {
        if (!prevProps.isShown) {
            this._manageA11y();
        }
        else if (!this.props.isShown) {
            document.removeEventListener('keyup', this._onEsc);
            this._focusLastActive();
        }
    }
    componentDidMount() {
        this._manageA11y();
    }
    componentWillUnmount() {
        document.removeEventListener('keyup', this._onEsc);
        this._focusLastActive();
    }
    render() {
        const { children, title, onClose, withArrow, arrowSide, arrowTop, withShadow, isShown, animated, className, closeAriaLabel, } = this.props;
        const pxArrowTop = `${arrowTop}px`;
        const titleToRender = typeof title === 'string' ? (React.createElement(Text, { className: classes.title }, title)) : (title);
        return (React.createElement(TPAComponentsConsumer, null, ({ rtl }) => {
            return (React.createElement("div", { className: st(classes.root, { rtl, arrowSide, withArrow, withShadow, isShown, animated }, className), "data-hook": this.props['data-hook'], ...this.getDataAttributes() },
                React.createElement("div", { className: classes.contentContainer },
                    titleToRender,
                    React.createElement("div", { className: classes.content }, children)),
                React.createElement(IconButton, { className: classes.close, onClick: onClose, "aria-label": closeAriaLabel, icon: React.createElement(Close, null), innerRef: this.iconRef }),
                React.createElement("div", { className: classes.arrow, style: { top: pxArrowTop } }),
                React.createElement("div", { className: `${classes.arrowBorder} ${classes.arrow}`, style: { top: pxArrowTop } })));
        }));
    }
}
CalendarPopover.displayName = 'CalendarPopover';
CalendarPopover.defaultProps = {
    title: '',
    withArrow: true,
    arrowSide: CalendarPopoverSides.Left,
    arrowTop: 42,
    withShadow: true,
    isShown: false,
    animated: false,
    manualFocus: false,
};
//# sourceMappingURL=CalendarPopover.js.map